import { CalendarEventOverlapMode } from 'vuetify/types'
import { stack } from './stack'
import { column } from './column'

export const CalendarEventOverlapModes: Record<string, CalendarEventOverlapMode> = {
  stack,
  column,
}



// WEBPACK FOOTER //
// ../../../../src/components/VCalendar/modes/index.ts